module.exports = __webpack_public_path__ + "img/jackpot-bg.562d9f1.webp";